import apiClient from '@/api/client'
import type { TeamMember } from '@/types/team.types'

const ENDPOINT = '/leadership-tree'

export const leadershipTreeService = {
  async getFullTree(params?: Record<string, string | boolean>): Promise<TeamMember[]> {
    const { data } = await apiClient.get<TeamMember[]>(ENDPOINT, { params })
    return data
  },

  async getMySubtree(): Promise<TeamMember[]> {
    const { data } = await apiClient.get<TeamMember[]>(`${ENDPOINT}/me/subtree`)
    return data
  },

  async getSubtree(authUserId: number): Promise<TeamMember[]> {
    const { data } = await apiClient.get<TeamMember[]>(`${ENDPOINT}/${authUserId}/subtree`)
    return data
  },

  async getDirectReports(authUserId: number): Promise<TeamMember[]> {
    const { data } = await apiClient.get<TeamMember[]>(`${ENDPOINT}/${authUserId}/direct-reports`)
    return data
  },

  async getAncestors(authUserId: number): Promise<TeamMember[]> {
    const { data } = await apiClient.get<TeamMember[]>(`${ENDPOINT}/${authUserId}/ancestors`)
    return data
  },
}
